module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTE5Mi43IDUxNS44bS03NC4yIDBhNzIuNSA3Mi41IDAgMSAwIDE0OC40IDAgNzIuNSA3Mi41IDAgMSAwLTE0OC40IDBaTTMxMC41IDYwOS40IDMxMC41IDQyMi4zIDkwNS41IDIzNi45IDkwNS41IDgzMS45WiIgcC1pZD0iOTk1Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/laba.svg
// module id = CcKs
// module chunks = 73